<template>
  <div/>
</template>
<script>
export default {
    name: 'FinishModule',
    props: {
        'module': {
            type: Object,
            required: true
        }
    },
    // data: function() { return {

    // }},
    computed: {
        isRdyToSend: function() {
            return false
        }
    },
    created() {
        this.setgoogleTag()
        Vue.set(this.$store.rdyToSend, 'M' + this.module.type, false)        
    },
    beforeDestroy() {
        Vue.delete(this.$store.rdyToSend, 'M' + this.module.type)
    },
    methods: {
        getResponseData() {
            return {}
        },
        setgoogleTag() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'calculationFinished'
            });
        }     
    },
}
</script>